declare global {
  interface Window {
    CustomEvent: typeof CustomEvent
  }
}

;(() => {
  // tslint:disable-next-line: strict-type-predicates
  if (typeof window.CustomEvent === 'function') {
    return
  }

  // tslint:disable-next-line: variable-name
  const CustomEvent = (
    ...args: ConstructorParameters<Window['CustomEvent']>
  ) => {
    const [eventName, params = {}] = args
    const { bubbles = false, cancelable = false, detail = null } = params

    const event = document.createEvent('CustomEvent')
    event.initCustomEvent(eventName, bubbles, cancelable, detail)

    return event
  }

  CustomEvent.prototype = Event.prototype

  window.CustomEvent = (CustomEvent as unknown) as Window['CustomEvent']
})()

export {}
